module.exports = __webpack_public_path__ + "static/media/BNB.92643887.png";